import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Instagram, Loader2, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { connectToInstagram } from "@/lib/instagramOAuth";
import { isSessionActive } from "@/lib/auth";

export default function ConnectInstagramButton({
  className = "",
  size = "lg",
  label = "Connect Instagram",
  testId = "connect-instagram-btn",
  signedInLabel = "Go to Dashboard",
  signedInTo = "/dashboard",
}) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [signedIn] = useState(() => isSessionActive());

  const sizes = {
    lg: "px-8 py-4 text-base md:text-lg",
    md: "px-6 py-3 text-sm md:text-base",
  };

  const handleClick = async () => {
    if (signedIn) {
      navigate(signedInTo);
      return;
    }
    setLoading(true);
    try {
      await connectToInstagram();
    } catch (e) {
      setLoading(false);
      if (e?.code === "MISSING_APP_ID") {
        toast.error("Instagram App ID not configured yet.", {
          description:
            "Set REACT_APP_INSTAGRAM_APP_ID in frontend/.env, then restart the frontend.",
        });
      } else {
        toast.error("Could not start Instagram login. Please try again.");
      }
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={loading}
      data-testid={testId}
      className={`cta-glow inline-flex items-center justify-center gap-3 rounded-full bg-sunset-gradient font-semibold text-white disabled:cursor-not-allowed disabled:opacity-80 ${sizes[size]} ${className}`}
    >
      {loading ? (
        <Loader2 className="animate-spin" size={20} />
      ) : signedIn ? (
        <ArrowRight size={20} strokeWidth={2.4} />
      ) : (
        <Instagram size={20} strokeWidth={2.4} />
      )}
      <span>{loading ? "Redirecting…" : signedIn ? signedInLabel : label}</span>
    </button>
  );
}

export function ConnectInstagramNote() {
  return (
    <p className="mt-2 text-xs text-ink/50">
      If Instagram asks for extra verification (captcha or a code), complete it, then click Connect again if you're not brought back here automatically.
    </p>
  );
}
